import React, { useEffect } from "react";
import { StatusStateEnum } from "~/types/enums";
import { Alert, Box, Card, Spinner, Text } from "~/components-shared";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Markdown from "~/components/Markdown";
import TrendingTopicCard from "~/components/TrendingTopicCard";
import trendReportSelectors from "~/store/trendReports/selectors";
import trendReportsActionCreators from "~/store/trendReports/actions";
import styled from "styled-components";
import { useQueryState } from "~/hooks/common";
import StyledIcon from "~/components/StyledIcon";
const StyledBox = styled(Box)`
  overflow: auto;
  position: relative;
  width: calc(100% + ${_ref => {
  let {
    theme
  } = _ref;
  return 26 / (theme.typography.fontSize / theme.spacing.step);
}}rem);

  &::-webkit-scrollbar {
    margin-left: 200px;
    width: 4px;
    height: 8px;
    background: transparent;
  }
  &::-webkit-scrollbar-track {
    background-color: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.grey.main;
}};
    margin-left: ${_ref3 => {
  let {
    theme
  } = _ref3;
  return 13 / (theme.typography.fontSize / theme.spacing.step);
}}rem;
    margin-right: ${_ref4 => {
  let {
    theme
  } = _ref4;
  return 13 / (theme.typography.fontSize / theme.spacing.step);
}}rem;
  }
`;
const BoxWrapper = styled.div`
  &:after {
    content: "";
    position: absolute;
    z-index: 1;
    width: 20px;
    height: calc(100% - 10px);
    top: 0;
    right: ${_ref5 => {
  let {
    theme
  } = _ref5;
  return -13 / (theme.typography.fontSize / theme.spacing.step);
}}rem;
    background: ${_ref6 => {
  let {
    theme
  } = _ref6;
  return theme.colors.gradients.secondaryBackground(90);
}};
  }
`;
const TrendingTopicsCard = _ref7 => {
  let {
    ...rest
  } = _ref7;
  const {
    t
  } = useTranslation();
  const historyReports = useSelector(trendReportSelectors.getHistoryReports);
  const [queryParams] = useQueryState({
    reportId: historyReports[0]?.id
  });
  const {
    reportId
  } = queryParams;
  const report = useSelector(trendReportSelectors.getReport(reportId));
  const reportStatus = useSelector(trendReportSelectors.getStatusByReport(reportId));
  const reportError = useSelector(trendReportSelectors.getErrorByReport(reportId));
  const historyStatus = useSelector(trendReportSelectors.getHistoryStatus);
  const historyError = useSelector(trendReportSelectors.getHistoryError);
  const error = historyError || reportError;
  const dispatch = useDispatch();
  const filteredTrends = report?.trends.filter(trend => !trend.isDismissed && !trend.theme.topic?.isFollowed) || [];
  useEffect(() => {
    if (historyStatus === StatusStateEnum.IDLE) {
      dispatch(trendReportsActionCreators.fetchHistoryStarted());
    }
  }, [dispatch, historyStatus]);
  useEffect(() => {
    if (reportId && reportStatus === StatusStateEnum.IDLE) {
      dispatch(trendReportsActionCreators.fetchOneStarted(reportId));
    }
  }, [dispatch, reportId, reportStatus]);
  if (!report && (reportStatus === StatusStateEnum.LOADING || historyStatus === StatusStateEnum.LOADING)) {
    return /*#__PURE__*/React.createElement(Card, rest, /*#__PURE__*/React.createElement(Spinner, {
      center: true
    }));
  }
  if (report?.trends.length && !filteredTrends.length) {
    return /*#__PURE__*/React.createElement(Card, rest, /*#__PURE__*/React.createElement(Box, {
      direction: "column",
      align: "center",
      s: {
        my: 8
      }
    }, /*#__PURE__*/React.createElement(StyledIcon, {
      src: "tick",
      color: "translucentSuccess"
    }), /*#__PURE__*/React.createElement(Text, {
      element: "h3",
      weight: "semiBold",
      display: "block",
      s: {
        mt: 6
      },
      align: "center",
      style: {
        maxWidth: "300px"
      }
    }, t("TrendingTopicsCard.allFollowed"))));
  }
  return /*#__PURE__*/React.createElement(Card, rest, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 6
    },
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Markdown, {
    text: error,
    linkColor: "text"
  })), report?.trends.length ? /*#__PURE__*/React.createElement(BoxWrapper, null, /*#__PURE__*/React.createElement(StyledBox, {
    wrap: "nowrap",
    align: "stretch",
    gap: 5,
    s: {
      p: 13,
      pb: 8,
      m: -13,
      mb: 0
    }
  }, filteredTrends.sort((a, b) => b.footprintCount - a.footprintCount).map(trend => /*#__PURE__*/React.createElement(TrendingTopicCard, {
    key: trend.id,
    width: "23.6%",
    reportId: reportId,
    trend: trend
  })))) : /*#__PURE__*/React.createElement(Box, {
    direction: "column",
    align: "center",
    s: {
      my: 8
    }
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    src: "hourglassEmpty"
  }), /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    weight: "semiBold",
    display: "block",
    s: {
      mt: 6
    }
  }, t("TrendingTopicsCard.noTrends")), /*#__PURE__*/React.createElement(Markdown, {
    color: "textSecondary",
    fontSize: 4,
    display: "block",
    s: {
      mt: 3,
      mb: 5
    },
    lineHeight: 6,
    style: {
      maxWidth: "400px"
    },
    align: "center",
    text: t("TrendingTopicsCard.noTrendsInfo")
  })));
};
export default TrendingTopicsCard;